import { render } from "./assessment-panel-placeholder.vue?vue&type=template&id=537e51a9&scoped=true&ts=true"
import script from "./assessment-panel-placeholder.vue?vue&type=script&lang=ts"
export * from "./assessment-panel-placeholder.vue?vue&type=script&lang=ts"

import "./assessment-panel-placeholder.vue?vue&type=style&index=0&id=537e51a9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537e51a9"]])

export default __exports__